var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "LeadView lead-details-window" }, [
    _c("div", { staticClass: "lead-details-window-wrapper" }, [
      _c(
        "div",
        { staticClass: "leads-details-content" },
        [
          _c(
            "div",
            { staticClass: "lead-view-container", attrs: { id: "lead-view" } },
            [_c("lead-view-left"), _vm._v(" "), _c("lead-view-right")],
            1
          ),
          _vm._v(" "),
          _c("router-link", {
            staticClass: "lead-details-close",
            attrs: { to: "/" },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }